export default __webpack_public_path__ + "static/media/biote_cobalt.9ce5cebd.png";